import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Route } from '../../../utils/route';
import { DictionaryService } from '../../../services/dictionary.service';
import { TabsComponent } from '../../../components/tabs/tabs.component';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirNavArrowLeft } from '@ng-icons/iconoir';
import { MainKpisComponent } from '../main-kpis/main-kpis.component';
import { CustomerVisitsTabComponent } from './customer-visits-tab/customer-visits-tab.component';
import { EvaluationsTabComponent } from './evaluations-tab/evaluations-tab.component';
import { MonthlyReportTabComponent } from './monthly-report-tab/monthly-report-tab.component';
import { PlannerTabComponent } from './planner-tab/planner-tab.component';
import { CallsLocationsTabComponent } from './calls-locations-tab/calls-locations-tab.component';
import { AccumulativeListTabComponent } from '../accumulative-list-tab/accumulative-list-tab.component';
import { TargetedFrequencyMetTabComponent } from './targeted-frequency-met-tab/targeted-frequency-met-tab.component';
import { ProductsPerformanceTabComponent } from '../products-performance-tab/products-performance-tab.component';
import { ClassesDistributionTabComponent } from '../classes-distribution-tab/classes-distribution-tab.component';
import { MarketSamplesTabComponent } from '../market-samples-tab/market-samples-tab.component';
import { ProductSamplesTabComponent } from '../product-samples-tab/product-samples-tab.component';
import { VisitsPerformanceTabComponent } from './visits-performance-tab/visits-performance-tab.component';

@Component({
  selector: 'app-user-details',
  imports: [
    NgIcon,
    TabsComponent,
    MainKpisComponent,
    CustomerVisitsTabComponent,
    EvaluationsTabComponent,
    MonthlyReportTabComponent,
    PlannerTabComponent,
    CallsLocationsTabComponent,
    AccumulativeListTabComponent,
    TargetedFrequencyMetTabComponent,
    ProductsPerformanceTabComponent,
    ClassesDistributionTabComponent,
    MarketSamplesTabComponent,
    ProductSamplesTabComponent,
    VisitsPerformanceTabComponent,
  ],
  providers: [provideIcons({ iconoirNavArrowLeft })],
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.scss',
})
export class UserDetailsComponent extends Route implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  protected dictionaryService = inject(DictionaryService);

  userId = signal<string>('');
  userName = signal<string>('');
  defaultTab = signal<string>('');

  get userInitial(): string {
    const name = this.userName();
    return name ? name.charAt(0).toUpperCase() : '?';
  }

  private storageKey(id: string): string {
    return `user_name_${id}`;
  }

  ngOnInit(): void {
    // Read userName from router state (passed from sales-performance-tab)
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state || history.state;
    const nameFromState = state?.['userName'] as string | undefined;

    this.route.params.subscribe((params) => {
      const id = params['id'] || '';
      this.userId.set(id);

      if (nameFromState) {
        // Fresh navigation — persist so reloads can recover it
        this.userName.set(nameFromState);
        localStorage.setItem(this.storageKey(id), nameFromState);
      } else {
        // Reload / direct URL — recover from localStorage
        const saved = localStorage.getItem(this.storageKey(id));
        if (saved) this.userName.set(saved);
      }
    });

    this.route.queryParams.subscribe((params) => {
      this.defaultTab.set(params['tab'] || '');
    });
  }

  onTabChange(tab: string): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  goBack(): void {
    this.router.navigate(['/users']);
  }
}
